// Import the custom footer component
import HDFooter from '../hd-ui-kit/HDFooter';
import React from 'react';

/**
 * Footer component renders the application footer using the HDFooter UI kit component.
 * It provides links to privacy, terms, legal notice, and contact, as well as social media and logo links.
 */
function Footer () {
  // Get the current site origin for local resource links
  const originHost = window.location.origin;

  // List of footer navigation items (policies, legal, contact)
  const footerItems = [
    {
      url: `${originHost}/res/privacy-policy.pdf`,
      itemName: 'Privacy Policy',
    },
    {
      url: `${originHost}/res/terms-of-use.pdf`,
      itemName: 'Terms of Use',
    },
    {
      url: 'https://www.heidrick.com/en/legal-notice',
      itemName: 'Legal Notice',
    },
    {
      url: 'https://heidricksupport.zendesk.com/hc/en-us',
      itemName: 'Contact',
    },
  ];

  // Social and logo URLs for the footer
  const logoUrls = {
    twitterUrl: 'https://twitter.com/heidrick',
    linkedInUrl: 'https://www.linkedin.com/company/heidrick-&-struggles',
    youtubeUrl: 'https://www.youtube.com/user/HeidrickStruggles',
    mainLogo: 'https://www.heidrick.com/en/',
  };

  // Render the HDFooter component with navigation and logo handlers
  return (
    <HDFooter
      logoUrls={logoUrls}
      footerItems={footerItems}
      logoClick={() => {}}
      onNavigationClick={(url) => window.open(url, '_blank', 'noopener,noreferrer')}
    />
  );
}

// Export the Footer component as default
export default Footer;